module.exports = __webpack_public_path__ + "3e735c572160db0ceceeb8c4097ec8c9.png";